import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  /** defaultTheme */
  :root{
    --medium-main:${(props) => props.theme.colors.main};

    --medium-purple:${(props) => props.theme.colors.purple};
    --medium-blue:${(props) => props.theme.colors.blue};
    --medium-lightBlue:${(props) => props.theme.colors.lightBlue};
    --medium-mint:${(props) => props.theme.colors.mint};
    --medium-lightmint:${(props) => props.theme.colors.lightMint};

    --medium-error:${(props) => props.theme.colors.error};
    --medium-success:${(props) => props.theme.colors.success};
    --medium-text:${(props) => props.theme.colors.text};
    --medium-subtext:${(props) => props.theme.colors.subText};
    --medium-border:${(props) => props.theme.colors.border};
    --medium-background:${(props) => props.theme.colors.background};

    --white:${(props) => props.theme.colors.white};
    --black:${(props) => props.theme.colors.black};

    --medium-min-width:${(props) => props.theme.size.minWidth};
    --medium-max-width:${(props) => props.theme.size.maxWidth};
  }

  /** global tag */
  p{
    white-space: pre-wrap;
  }

  i{
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    background: no-repeat center;
    background-size: 16px;
    transform: translateY(-1px) translateX(-2px);
    &.window {
      margin-left: 5px;
      background-image: url('/asset/svg/i-window.svg');
    }
    &.copy {
      background-image: url('/asset/svg/i-copy.svg');
    }
    &.success {
      width: 20px;
      height: 20px;
      background-size: 20px;
      background-image: url('/asset/svg/i-success.svg');
    }
    &.info {
      width: 20px;
      height: 20px;
      background-size: 20px;
      background-image: url('/asset/svg/i-info.svg');
    }
    &.error {
      background-image: url('/asset/svg/i-error.svg');
    }
    &.history {
      width: 24px;
      height: 24px;
      background-size: 24px;
      background-image: url('/asset/svg/i-history.svg');
    }
    &.process {
      width: 24px;
      height: 24px;
      background-size: 24px;
      background-image: url('/asset/svg/i-process.svg');
    }
    &.hand {
      display: block;
      margin: 0 auto 12px;
      width: 48px;
      height: 48px;
      background-size: 48px;
      background-image: url('/asset/svg/i-hand.svg');
    }
    &.alert {
      display: block;
      margin: 0 auto 12px;
      width: 48px;
      height: 48px;
      background-size: 48px;
      background-image: url('/asset/svg/i-alert.svg');
    }
  }
`;
